"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
var card_elevation_props_1 = require("./card_elevation_props");
var card_styles_1 = require("./card_styles");
var merge_1 = __importDefault(require("lodash/merge"));
var useStyles = makeStyles_1.default(card_styles_1.styles);
var CardComponent = function (_a) {
    var _b = _a.component, Component = _b === void 0 ? 'div' : _b, className = _a.className, containerRef = _a.containerRef, _c = _a.elevation, elevation = _c === void 0 ? 1 : _c, style = _a.style, _d = _a.customClasses, oldCustomClasses = _d === void 0 ? {} : _d, _e = _a.classes, receivedClasses = _e === void 0 ? {} : _e, variant = _a.variant, other = __rest(_a, ["component", "className", "containerRef", "elevation", "style", "customClasses", "classes", "variant"]);
    var mergedClasses = react_1.useMemo(function () { return merge_1.default({}, oldCustomClasses, receivedClasses); }, [
        JSON.stringify(oldCustomClasses),
        JSON.stringify(receivedClasses),
    ]);
    var classes = useStyles({ classes: mergedClasses });
    var stylePropsFromVariant = react_1.useMemo(function () {
        if (!variant) {
            return card_elevation_props_1.ELEVATION_PROPS.regular;
        }
        return card_elevation_props_1.ELEVATION_PROPS === null || card_elevation_props_1.ELEVATION_PROPS === void 0 ? void 0 : card_elevation_props_1.ELEVATION_PROPS[variant];
    }, [variant]);
    var styleProps = __assign({}, stylePropsFromVariant === null || stylePropsFromVariant === void 0 ? void 0 : stylePropsFromVariant[elevation]);
    // @ts-ignore
    var variantClass = variant && classes["variant_" + variant];
    return react_1.default.createElement(Component || 'div', __assign({ ref: containerRef, className: classnames_1.default(classes.container, variantClass, className), style: __assign(__assign({}, (stylePropsFromVariant && styleProps)), style) }, other));
};
exports.Card = CardComponent;
